import autoBind from 'react-autobind';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import {Link} from 'react-router';
import {Map} from 'immutable';
import RaisedButton from 'material-ui/RaisedButton';
import RetinaImage from 'react-retina-image';

import {Card, CardActions, CardText} from 'material-ui/Card';
import {PasswordInput, TextInput} from '../../shared/components';
import React, {Component, PropTypes} from 'react';

export default class LogInForm extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);

    this.passwordTextFieldRef = null;
    this.emailTextFieldRef = null;
  }

  componentDidMount() {
    // There's a bug with the TextField and Chrome's autofilling of the password field. When Chrome autofills a password input,
    //  the value can't be accessed, so the TextField doesn't know it's there (and our state is empty) until the user interacts with the page.
    // We focus the password by default if the user has an email entered on component mount in order to prevent the password placeholder
    //  from showing behind the password autofill text when the page initially loads.
    const focusPassword = () => {
      if (this.emailTextFieldRef.getValue()) {
        this.passwordTextFieldRef.focus();
      }
    };

    setTimeout(focusPassword.bind(this), 500);
  }

  setPasswordRef(ref) {
    this.passwordTextFieldRef = ref;
  }

  setEmailRef(ref) {
    this.emailTextFieldRef = ref;
  }

  render() {
    const {
      model,
      onFieldChange,
      onSubmit,
      submitting,
    } = this.props;

    const forgotPasswordStyle = {
      fontSize: 11,
      fontWeight: 400,
      paddingLeft: 10,
      paddingRight: 0,
    };

    const backToHomeStyle = {
      fontSize: 14,
      paddingLeft: 15,
      paddingRight: 0,
    };

    return (
      <div className="pre-dashboard-container">
        <div className="title">Sign in to TEAMology</div>
        <Card zDepth={1}>
          <a href="http://www.teamology.team">
            <FlatButton
              label="back to TEAMology home"
              hoverColor="#FFFFFF"
              rippleColor="#FFFFFF"
              tabIndex={-1}
              labelStyle={backToHomeStyle}
              icon={<i className="fa fa-arrow-left" />} />
          </a>
          <form onSubmit={onSubmit} className="log-in-form">
            <CardText>
              <div className="login-image">
                <RetinaImage src={[require('../images/img-signinHouse.png'), require('../images/img-signinHouse@2x.png')]} />
              </div>
              <div disabled={submitting}>
                <TextInput textFieldRef={this.setEmailRef} id="email" floatingLabelText="Email" value={model.get('email')} onChange={onFieldChange} />
                <PasswordInput textFieldRef={this.setPasswordRef} id="password" floatingLabelText="Password" value={model.get('password')} onChange={onFieldChange} />
              </div>
            </CardText>
            <CardActions className="log-in-actions">
              <FlatButton
                label="Forgot Password?"
                hoverColor="#FFFFFF"
                rippleColor="#FFFFFF"
                tabIndex={-1}
                containerElement={<Link to="/request-password-reset" />}
                labelStyle={forgotPasswordStyle} />
              <RaisedButton
                style={{fontSize: 14, fontWeight: 700}}
                className="raised-button--rounded"
                type="submit"
                secondary
                disabled={submitting || !model.get('email') || !model.get('password')}>{submitting ? 'Signing In...' : 'Sign In'}</RaisedButton>
            </CardActions>
            <CardActions className="extra-links">
              <a href="http://www.teamology.team/educators">
                <FlatButton
                  label="Not a TEAM Member? Sign up now."
                  hoverColor="#FFFFFF"
                  rippleColor="#FFFFFF"
                  tabIndex={-1}/>
              </a>
            </CardActions>
          </form>

        </Card>
        <div className="footer">
          <div>Copyright 2017 TEAMology, LLC</div>
          <div>Terms of Use</div>
        </div>
      </div>
    );
  }
}

LogInForm.propTypes = {
  model: PropTypes.instanceOf(Map).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/authentication/components/LogInForm.js